/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsBucket
 */
export interface AllShipmentsBucket {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsBucket
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsBucket
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsBucket
   */
  bookedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsBucket
   */
  avgPrice?: number | null;
}

/**
 * Check if a given object implements the AllShipmentsBucket interface.
 */
export function instanceOfAllShipmentsBucket(
  value: object,
): value is AllShipmentsBucket {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("bookedCount" in value) || value["bookedCount"] === undefined)
    return false;
  return true;
}

export function AllShipmentsBucketFromJSON(json: any): AllShipmentsBucket {
  return AllShipmentsBucketFromJSONTyped(json, false);
}

export function AllShipmentsBucketFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsBucket {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    count: json["count"],
    bookedCount: json["bookedCount"],
    avgPrice: json["avgPrice"] == null ? undefined : json["avgPrice"],
  };
}

export function AllShipmentsBucketToJSON(json: any): AllShipmentsBucket {
  return AllShipmentsBucketToJSONTyped(json, false);
}

export function AllShipmentsBucketToJSONTyped(
  value?: AllShipmentsBucket | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    count: value["count"],
    bookedCount: value["bookedCount"],
    avgPrice: value["avgPrice"],
  };
}
